<template>
  <div>
    <b-list-group>
      <b-list-group-item v-for="item in navlist" :key="item.index">
        <b-link :to="item.link">{{item.title}}</b-link>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navlist: [
          {
              title: "Obtaining Loan",
              link: "/faqs"
          },
          {
              title: "Repayment of Loan",
              link: "/faqs/loan-repayment"
          },
          {
              title: "Meet Loan Company",
              link: "/faqs/about-company"
          },
          {
              title: "Lend Responsibly",
              link: "/faqs/responsibles"
          }
        ]
    };
  }
};
</script>

<style lang="scss" scoped>
.list-group {
  margin-bottom: 40px;
  .list-group-item {
    padding: 0;
    a {
      color: #434343;
      text-decoration: none;
      padding: 12px 20px;
      display: block;
    }
    .router-link-exact-active {
      background: $base-blue-nav;
      color: #fff;
    }
  }
  .list-group-item.active {
    a {
      color: #fff;
    }
  }
}
</style>